import WebComponent from "webcomponent";
import template from "./hmi.svg.html";
import css from "./hmi.css";

export default class HMI extends WebComponent {
  #onupdatestate_handler;
  #onupdatealarms_handler;
  
  static {
    customElements.define("biocore-hmi", HMI);
  }

  static get template() {
    return template;
  }

  static get css() {
    return css;
  }

  static get schema() {
    return({
      "type": "object",
      "description": "Our custom HMI",
      "properties": {
      }
    });
  }

  static get designer() {
    return({
      "category": "Basic",
      "icon": {"context": "actions", "size": 16, "iconname": "insert-text"}
    });
  }

  async connectedCallback(...args) {
    await super.connectedCallback(...args);

    const response = await fetch("/page/overview/hmi.svg", {
      method: "GET",
      headers: {
        "Accept": "image/svg+xml"
      }
    });

    if (!response.ok) {
      throw new Error(`Failed to load overview.svg: ${response.statusText}`);
    }

    const svgText = await response.text();

    const parser = new DOMParser();
    const svgDoc = parser.parseFromString(svgText, "image/svg+xml");

    const svgElement = svgDoc.documentElement;

    this.appendChild(svgElement);
    
    //add event listeners
    document.addEventListener(
      "onupdatestate",
      this.#onupdatestate_handler
    );

    //add event listeners
    document.addEventListener(
      "onupdatealarms",
      this.#onupdatealarms_handler
    );
    
 
  }

  async disconnectedCallback(...args) {
    await super.disconnectedCallback(...args);
    
    document.removeEventListener(
      "onupdatestate",
      this.#onupdatestate_handler
    );   

    document.removeEventListener(
      "onupdatealarms",
      this.#onupdatealarms_handler
    );   
    
  }

  constructor(...args) {
    super(...args);
    this.#onupdatestate_handler =
      this.onupdatestate_handler.bind(this);  

    this.#onupdatealarms_handler =
      this.onupdatealarms_handler.bind(this);      
  }

  async onupdatestate_handler(event) {
    const state = event.detail;
    this.#updateDevices(state.devices);
    this.#updateActiveFermentation(state.fermentation);
    console.log(state.fermentation);
    //this.#updateAlarms(state.alarms);
  }

  async #updateDevices(devices) {
    //update devices state    
    devices = Object.values(devices).map(obj => ({ ...obj }));

    for (const device of devices) {
      const name = device.name;

      // Select all matching text elements
      const texts = this.shadowRoot.querySelectorAll(`text[data-name="${name}"]`);

      if (!texts.length) {
        continue;
      }

      for (const text of texts) {
        const value = device[text.dataset.value];
        const ok = device['status'].toLowerCase() == 'ok';

        // Find or create tspan
        let tspan = text.querySelector("tspan");

        if (!tspan) {
          tspan = document.createElementNS("http://www.w3.org/2000/svg", "tspan");
          text.appendChild(tspan);
        }

        tspan.textContent = ok ? value : "-";
      }
    }
  }

  async #updateActiveFermentation(activeFermentation = {}) {
    const texts = this.shadowRoot.querySelectorAll(
      'text[data-name="activeFermentation"]'
    );

    for (const text of texts) {
      const key = text.dataset.value;
      const value = activeFermentation?.[key];

      let tspan = text.querySelector("tspan");

      if (!tspan) {
        tspan = document.createElementNS(
          "http://www.w3.org/2000/svg",
          "tspan"
        );
        text.appendChild(tspan);
      }

      tspan.textContent = Number.isFinite(value) ? value : "-";
    }
  }

  async onupdatealarms_handler(event) {
    let alarms = event.detail;
    
    const ellipses = this.shadowRoot.querySelectorAll('ellipse[data-name]');

    for (const ellipse of ellipses) {
      const name = ellipse.dataset.name;

      const alarm = alarms.find(a => a.name === name);

      const state = alarm ? (alarm.state || "off").toLowerCase() : "off";

      ellipse.setAttribute('data-state', state);
    }    
    
  }

}